export const headerAnimate = {
  hide: {
    opacity: 0,
    y: -180,
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      ease: "easeOut",
      duration: 2,
      delay: 2,
    },
  },
};

export const letterAnimate = {
  hide: {
    y: 400,
  },
  show: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 2,
    },
  },
};

export const letterAnimation = {
  hide: {
    y: 400,
  },
  show: {
    y: 0,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.7,
    },
  },
};


export const textAnimate = {
  hide: {
    y: 70,
    opacity: 0,
  },
  show: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      bounce: 0.2,
      duration: 2,
    },
  },
};